import { gql } from 'apollo-angular';

export const AUTHORIZED_JURISDICTION_INFO = gql`
  query GetAuthorizedJurisdictionInfo(
    $skip: Int
    $take: Int
    $tenantId: UUID!
    $where: AuthorizedJurisdictionFilterInput
  ) {
    authorizedJurisdictions(
      skip: $skip
      take: $take
      tenantId: $tenantId
      where: $where
    ) {
      items {
        id
        authorizedTenantId
        canCopyMaster
        wageAccessType {
          id
          name
          accessType
          permissions
          createdDate
          createdBy
          modifiedDate
          modifiedBy
        }
        jurisdiction {
          jurisdictionTypeId
          wageRateTemplateTypeId
          wageModificationTypeId
          name
          isFhwa
          jurisdictionType {
            name
            description
            id
            createdDate
            createdBy
            modifiedDate
            modifiedBy
          }
          wageRateTemplateType {
            name
            rateTemplateType
            id
            createdDate
            createdBy
            modifiedDate
            modifiedBy
          }
          wageModificationType {
            name
            modificationType
            id
            createdDate
            createdBy
            modifiedDate
            modifiedBy
          }
          id
          createdDate
          createdBy
          modifiedDate
          modifiedBy
        }
        createdDate
        createdBy
        modifiedDate
        modifiedBy
      }
    }
  }
`;
